import React from 'react';
import ReactDOMServer from 'react-dom/server';

import './FeedContent.css';
import $ from 'jquery';
import {encrypt} from "../../../helpers/CryptoJs"
import Linkify from 'react-linkify';

const FeedContent = ({content,post_date}) => { 
    content = content.replace(/href='(.+?)'>/g, function(m, $1) {

        if(isNaN($1) == true){
            return 'href='+$1+' target="_blank" class="hyperlinkss">';
            
        }else{
           
            let newUrl = `/user/${encrypt($1)}`;
            return 'href='+newUrl+' >';
            
        }
    })

    content = content.replace(/href="(.+?)">/g, function(m, $1) {

        if(isNaN($1) == true){
            return 'href='+$1+' target="_blank" class="hyperlinkss">';
            
        }else{
         
            let newUrl = `/user/${encrypt($1)}`;
            return 'href='+newUrl+' >';
            
        }
    })

    content = content.replace(/href=(.+?)>/g, function(m, $1) {
            if(!$1.includes('user')){
                if(isNaN($1) == true){
                   
                    return 'href='+$1+' target="_blank" class="hyperlinkss">';
                    
                    
                }else{
                   
                    let newUrl = `/user/${encrypt($1)}`;
                    return 'href='+newUrl+' >';
                    
                }
            }else{
                return 'href='+$1+'>';
            }
        
    }) 
    const linkify = (text) => ReactDOMServer.renderToStaticMarkup(<Linkify>{text}</Linkify>)
    let res = linkify(content);
    res = res.replace(/&lt;/gi, '<');
    res = res.replace(/&gt;/gi, '>');
    res = res.replace(/&#x27;/gi, '"');
    res = res.replace(/&amp;nbsp;/, ' ');
    //console.log(res);
    
    return (
        
            <div>
                <p dangerouslySetInnerHTML={{ __html: ' '+res+ ' ' }}></p>
            </div>
      
    );
};

export default FeedContent;